import { Deserializable } from './deserializable.model';

export class Image implements Deserializable {
  path = '';
  signedUrl = '';
  title = '';
  mimetype = '';
  size = 0;
  empty = false;
  url = ''

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}
